import { useCallback, useRef } from 'react';

export const useScrollSync = () => {
  const aRef = useRef<HTMLDivElement>(null);
  const bRef = useRef<HTMLDivElement>(null);

  const onAScroll = useCallback(() => {
    if (aRef.current && bRef.current) bRef.current.scrollTop = aRef.current.scrollTop;
  }, []);

  const onBScroll = useCallback(() => {
    if (aRef.current && bRef.current) aRef.current.scrollTop = bRef.current.scrollTop;
  }, []);

  return { aRef, bRef, onAScroll, onBScroll };
};
